<div>
  <div class="tooltip-container" [ngClass]="tooltipClass">
    <ng-template #simpleText>{{text}}</ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText; context: tooltipContext"> </ng-container>
  </div>
</div>
